import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive/src';
import { AwardActions } from 'modules/awards/action';
import { AwardSelector } from 'modules/awards/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { ProjectActions } from 'modules/project/actions';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectBrowserActions } from 'modules/projectBrowser/actions';
import { ProjectBrowserSelector } from 'modules/projectBrowser/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import ProjectAmenitiesViewControl from 'components/organisms/projectAmenitiesViewControl';
import ProjectDetailsBanner from 'components/organisms/projectDetailsBanner';
import Award from 'components/templates/awards';
import FooterSection from 'components/templates/footer';
import NeighbourhoodGuide from 'components/templates/neighborhoodGuide';
import PageTemplate from 'components/templates/pageTemplate';
import ProductBrowser from 'components/templates/productBrowser';
import ImageGallerySection from 'components/templates/imageGallerySection';
import { VirtualTourSection } from 'components/templates/virtualTourSection';
import OurHomesDifferences from 'components/templates/ourHomesDifference';
import { ContactUsSection } from 'components/templates/contactUsSection';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import { ShareModal } from 'components/templates/shareModal';
import { RouteNames } from 'router';
import ConstructionGallerySection from 'components/templates/constructionGallery';
import RenderSEO from 'components/atoms/renderSEO';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { HeaderButtons } from 'components/atoms/headerButtons';
import CompletedProjectsSection from 'components/templates/completedProjectsSection';
import { PROJECT_FILE_DOWNLOAD_URL } from 'config/env';
import { DownloadBrochureModal } from 'components/templates/downloadBrochureModal';
import Testimonial from 'components/templates/testimonial';
import { VideosSelector } from 'modules/videos/selector';
import { VideoActions } from 'modules/videos/action';
import { ProjectAnnouncementsSection } from 'components/templates/projectAnnouncementsSection';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

const WorkspaceDetails = props => {
  const {
    isLoading,
    getVerticals,
    verticals,
    verticalId,
    getContactDetails,
    contact,
    getSiteSettings,
    siteSettings,
    getAnnouncements,
    announcements,
    getProjectDetails,
    getParticularProductDetails,
    projectDetails,
    getProjects,
    recommendedList,
    awardData,
    getAwardData,
    particularProductDetails,
    getNeighbourhoodGuide,
    neighbourhoodDetails,
    getGalleryForProject,
    gallery,
    getPageData,
    ourDifferenceData,
    cmsDetailsData,
    getCmsDetailsData,
    getConstructionGalleryForProject,
    constructionGallery,
    getProductBrowser,
    getBannerData,
    footerLink,
    getFooterLinkData,
    getProjectBrochure,
    projectBrochure,
    videosData,
    getVideosData,
  } = props;

  const project_url_slug = props.match.params.workspaceSlug;
  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });

  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isGetInTouchModalOpen, setIsGetInTouchModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isBrochureModalOpen, setIsBrochureModalOpen] = useState(false);
  const [mapView, setMapView] = useState(false);
  const type = 'project';

  useEffect(() => {
    getProjectDetails(project_url_slug);
    getAnnouncements(verticalId, project_url_slug);
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getNeighbourhoodGuide();
    getProjects();
    getPageData();
    getBannerData();
    getCmsDetailsData();
    getFooterLinkData();
    getParticularProductDetails(project_url_slug);
    getGalleryForProject(project_url_slug);
    getAwardData(verticalId, project_url_slug);
    getConstructionGalleryForProject(project_url_slug);
    getProductBrowser();
    getProjectBrochure(project_url_slug);
    getVideosData(null, project_url_slug, type);
  }, [project_url_slug, verticalId]);

  const hasData = () => {
    return (
      awardData &&
      gallery &&
      siteSettings &&
      verticals &&
      announcements &&
      neighbourhoodDetails &&
      recommendedList &&
      projectDetails &&
      cmsDetailsData &&
      constructionGallery &&
      projectBrochure &&
      videosData &&
      footerLink
    );
  };

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (!hasData()) {
    return null;
  }

  const projectName = get(projectDetails, 'project.title', '');
  const metaTagSEO = projectDetails.project.metaTagSEO;

  // Get in touch
  const onGetInTouchClick = () => {
    setIsGetInTouchModalOpen(true);
  };

  const closeGetInTouchModal = () => {
    setIsGetInTouchModalOpen(false);
  };
  // Brochure
  const onBrochureClick = () => {
    setIsBrochureModalOpen(true);
  };

  const closeBrochureModal = () => {
    setIsBrochureModalOpen(false);
  };

  // Share
  const onShareClick = () => {
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const updateMapView = (theme, view) => {
    setTheme(theme);
    setMapView(view);
  };

  const CampaignCode = contact.campaignCode ? contact.campaignCode : '';
  let project = projectDetails && projectDetails.project;
  const CampaignBrochureCode = project.brochure_campaign_code
    ? project.brochure_campaign_code
    : '';
  let pdfUrl =
    project.brochure && `${PROJECT_FILE_DOWNLOAD_URL}${project.brochure}`;

  const componentList = [
    ...(!isEmpty(projectDetails)
      ? [
          {
            component: ProjectDetailsBanner,
            data: { projectDetails },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `${projectName}`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(announcements)
      ? [
          {
            component: ProjectAnnouncementsSection,
            data: {
              announcements,
              onGetInTouchClick: setIsGetInTouchModalOpen,
              checkForCTAButton: true,
            },
            sectionId: 'announcements',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: 'Announcements',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            sectionName: 'announcement-section',
          },
        ]
      : []),
    ...(!isEmpty(gallery)
      ? [
          {
            component: ImageGallerySection,
            data: { images: gallery },
            theme: 'dark-theme',
            sectionId: 'gallery',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `Gallery`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(projectDetails.project.virtualTours)
      ? [
          {
            component: VirtualTourSection,
            data: {
              data: projectDetails.project.virtualTours || [],
            },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'virtual-tours',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `360\u00B0 Tour`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(particularProductDetails)
      ? [
          {
            component: ProductBrowser,
            data: {
              productData: particularProductDetails,
              projectDetails: projectDetails.project,
              onGetInTouchClick,
              breadcrumb: projectName,
              type: "Workations"
            },
            sectionId: 'products',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `Product Browser`,
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: OurHomesDifferences,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'our-differences',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: 'Our Differences',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(neighbourhoodDetails.list)
      ? [
          {
            component: NeighbourhoodGuide,
            data: {
              data: neighbourhoodDetails,
              updateMapView,
              mapView,
              breadcrumb: projectName,
            },
            sectionId: 'neighbourhood-guide',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `Neighbourhood Guide`,
                breadcrumbLink: '#',
              },
            ],
            theme: isMobile ? 'dark-theme' : 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(projectDetails.project_amenities)
      ? [
          {
            component: ProjectAmenitiesViewControl,
            data: {
              data: projectDetails,
              onBrochureClick,
              pdfUrl,
            },
            theme: !isMobile ? 'light-theme' : 'dark-theme',
            sectionId: 'amenities',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `Amenities`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(projectBrochure)
      ? [
          {
            component: CompletedProjectsSection,
            data: {
              completedProjects: projectBrochure,
              sectionHeading: 'Project Details',
              onGetInTouchClick,
            },
            theme: 'light-theme',
            sectionId: 'completed-projects',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: 'Project Details',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(constructionGallery)
      ? [
          {
            component: ConstructionGallerySection,
            data: { constructionGallery },
            theme: 'light-theme',
            sectionId: 'construction-gallery',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: `Construction Gallery`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(awardData)
      ? [
          {
            component: Award,
            sectionId: 'awards',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: 'Awards',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: awardData,
          },
        ]
      : []),
    ...(!isEmpty(videosData)
      ? [
          {
            component: Testimonial,
            sectionId: 'videos',
            theme: 'dark-theme',
            data: { testimonialData: videosData, type: 'videos' },
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Workcations',
                breadcrumbLink: RouteNames.workcations,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Videos',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: {
        contact,
        verticals,
        verticalId,
        projectName,
        callPostLeadAPI: true,
        type: 'no-padding',
      },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Workcations',
          breadcrumbLink: RouteNames.workcations,
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Workcations',
          breadcrumbLink: RouteNames.workcations,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <div>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={project_url_slug} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        campaignCode={CampaignCode}
        projectInterested={projectName}
        salesEmail={contact.email}
        headerButtons={
          <HeaderButtons
            shareTheme={'dark'}
            getInTouchTheme={'light'}
            setIsModalOpen={setIsGetInTouchModalOpen}
            setIsShareModalOpen={setIsShareModalOpen}
          />
        }
      />
      <DownloadBrochureModal
        isOpen={isBrochureModalOpen}
        onClosePress={closeBrochureModal}
        campaignCode={CampaignBrochureCode}
        projectInterested={projectName}
        salesEmail={contact.email}
        callPostLeadAPI={true}
        pdfUrl={pdfUrl}
      />
      <GetInTouchModal
        isOpen={isGetInTouchModalOpen}
        onClosePress={closeGetInTouchModal}
        campaignCode={CampaignCode}
        projectInterested={projectName}
        salesEmail={contact.email}
        callPostLeadAPI={true}
        verticalId={verticalId}
      />
      <ShareModal
        isOpen={isShareModalOpen}
        onClosePress={closeShareModal}
        callPostLeadAPI={true}
      />
    </div>
  );
};

const mapStateToProps = state => {
  const verticalKey = 'workcations';

  return {
    isLoading:
      ProjectSelector.isDetailsPageLoading(state) ||
      AwardSelector.isLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      FooterSelector.isLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state) ||
      VideosSelector.isLoading(state) ||
      ProjectSelector.getAnnouncementsLoading(state),
    awardData: AwardSelector.getAwardData(state),
    gallery: ProjectSelector.getGallery(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    verticals: HomeSelector.getVerticals(state),
    footerLink: FooterSelector.getFooterData(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    contact: HomeSelector.getContactForProject(state),
    announcements: ProjectSelector.getAnnouncements(state),
    neighbourhoodDetails: ProjectSelector.getNeighbourhoodGuide(state),
    particularProductDetails: ProjectBrowserSelector.getParticularProductDetails(
      state
    ),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'our-difference',
      'Workcations',
      HomeSelector.getVerticalIdForKey(verticalKey)
    ),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
    projectDetails: ProjectBrowserSelector.getProjectDetails(state),
    recommendedList: ProjectBrowserSelector.getRecommendedProject(state),
    constructionGallery: ProjectSelector.getConstructionGallery(state),
    projectBrochure: ProjectSelector.getProjectBrochure(state),
    videosData: VideosSelector.getVideosData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getVerticals,
    getSiteSettings,
    getContactDetails,
    getBannerData,
  } = HomeActions;
  const { getAwardData } = AwardActions;
  const { getPageData } = CmsPagesActions;
  const {
    getProjectDetails,
    getParticularProductDetails,
  } = ProjectBrowserActions;
  const {
    getGalleryForProject,
    getNeighbourhoodGuide,
    getProjects,
    getConstructionGalleryForProject,
    getProjectBrochure,
    getAnnouncements,
  } = ProjectActions;
  const { getCmsDetailsData } = CmsDetailsActions;
  const { getProductBrowser } = ProductBrowserAction;
  const { getVideosData } = VideoActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getContactDetails,
      getVerticals,
      getSiteSettings,
      getAwardData,
      getProjectDetails,
      getPageData,
      getParticularProductDetails,
      getNeighbourhoodGuide,
      getGalleryForProject,
      getProjects,
      getCmsDetailsData,
      getConstructionGalleryForProject,
      getProductBrowser,
      getBannerData,
      getProjectBrochure,
      getVideosData,
      getAnnouncements,
      getFooterLinkData,
    },
    dispatch
  );
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WorkspaceDetails)
);
